import { http } from '@/lib/http';
import type { APIResponse } from '@/types';
import type { LotteryEventDetail } from '@monorepo/common';

export type GetLotteryEventDetailParams = {
  id: number;
  hash?: string;
  oemServiceId: number;
  branchKey?: string;
};

export type GetLotteryEventDetailResponse = APIResponse<LotteryEventDetail>;

export const getLotteryEventDetail = async (params: GetLotteryEventDetailParams) => {
  return await http<GetLotteryEventDetailResponse>(`/user/v1/lottery-event/${params.id}`, {
    query: {
      hash: params.hash,
      oem_service_id: params.oemServiceId,
      branch_key: params.branchKey,
    },
  });
};
